// walletApi.js
// Restaurant wallet / cashout (Stripe Connect Express). Staff-only endpoints — same
// dormant staffKey pattern as api.js (getOrders/updateOrder) and restaurantsApi.js.

const API_BASE = 'https://z51smv2b7g.execute-api.ap-southeast-2.amazonaws.com/prod';
const STAFF_KEY = process.env.REACT_APP_STAFF_KEY || '';

export async function getWallet(restaurantId) {
  const params = new URLSearchParams({ restaurantId });
  if (STAFF_KEY) params.append('staffKey', STAFF_KEY);
  const res = await fetch(`${API_BASE}/wallet?${params.toString()}`);
  if (!res.ok) throw new Error('Failed to load wallet');
  return res.json(); // { balance: { totalEarned, totalPaidOut, available }, transactions: [...] }
}

export async function requestCashout(restaurantId, amount) {
  const url = STAFF_KEY
    ? `${API_BASE}/wallet?staffKey=${encodeURIComponent(STAFF_KEY)}`
    : `${API_BASE}/wallet`;
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ restaurantId, ...(amount != null && { amount }) }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Cashout failed');
  return data;
}

export async function startOnboarding(restaurantId) {
  const url = STAFF_KEY
    ? `${API_BASE}/connect-onboarding?staffKey=${encodeURIComponent(STAFF_KEY)}`
    : `${API_BASE}/connect-onboarding`;
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ restaurantId }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Could not start onboarding');
  return data; // { url, stripeAccountId }
}

// Creates a restaurant owner's login + their restaurant mapping. Staff-only, and the
// backend fails closed if STAFF_API_KEY isn't configured (it mints real credentials).
// Returns a one-time temporary password to hand to the owner directly.
export async function inviteRestaurantOwner({ email, restaurantId, invitedBy }) {
  const url = STAFF_KEY
    ? `${API_BASE}/partner/auth/invite?staffKey=${encodeURIComponent(STAFF_KEY)}`
    : `${API_BASE}/partner/auth/invite`;
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, restaurantId, invitedBy }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Could not send the invite');
  return data;
}

const walletApi = { getWallet, requestCashout, startOnboarding, inviteRestaurantOwner };
export default walletApi;
